import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Store from "@/store";
import Home from "../views/Home.vue";
import Erradicacion from "../views/menu/Erradicacion.vue";
import Bateas from "../views/menu/Bateas.vue";
import Recoleccion from "../views/menu/Recoleccion.vue";
import Moviles from "../views/menu/Moviles.vue";
import Contacto from "../views/menu/Contacto.vue";
import Certificados from "../views/menu/Certificados.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home
  },

  {
    path: "/erradicacion_microbasurales",
    name: "Erradicacion",
    component: Erradicacion
  },

  {
    path: "/mas_bateas_por_sector",
    name: "Bateas",
    component: Bateas
  },

  {
    path: "/recoleccion_domicilaria",
    name: "Recoleccion",
    component: Recoleccion
  },

  {
    path: "/puntos_limpios_moviles",
    name: "Moviles",
    component: Moviles
  },

  {
    path: "/contacto/asad",
    name: "Contacto",
    component: Contacto
  },

  {
    path: "/certificados_de_transporte_de_residuos",
    name: "Certificados",
    component: Certificados
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  Store.commit("SET_CURRENT_PAGE", to.name);
  next();
});
export default router;
